import NavbarOption from "../assets/NavbarOption.svg";
import React, { useState } from "react";
import "./css/headerTextbar.css";
import { Link } from "react-router-dom";
import FeedBackModal from "./FeedBackModal";
const HeaderTextEditor = ({ toggleSidebar }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <FeedBackModal showModal={showModal} handleClose={handleClose} />
      <div className="TextBarHead">
        <div className="ImgLogoCont">
          <div className="imgLogo">
            <button onClick={toggleSidebar}>
              {" "}
              <img src={NavbarOption} alt="sidebar"></img>
            </button>
          </div>
          <h5 style={{ fontSize: "16px", marginTop: "0.3rem" }}>
            {" "}
            <Link to="/" style={{ color: "white", textDecoration: "none" }}>
              {" "}
              CHATGPT NOTEPAD
            </Link>
          </h5>
        </div>
        <div className="header_editor_texts">
          <div className="secondCont">
            <p className="nav-item">
              <button className="nav-link" style={{ fontSize: "12px" }}>
                <Link
                  to="/SaleProduct"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  OWN THIS PRODUCT
                </Link>
              </button>
            </p>
          </div>
          <div className="secondCont">
            <p className="nav-item">
              <button
                className="nav-link"
                style={{ fontSize: "12px" }}
                onClick={handleShow}
              >
                FEEDBACK
              </button>
            </p>
          </div>
          <div className="secondCont">
            <li
              className="nav-item"
              style={{ fontSize: "12px", listStyle: "none" }}
            >
              <a
                href="https://www.triosoft.ai/HireDevelopers"
                className="nav-link cta-navbar-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hire Developers
              </a>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTextEditor;
